import SelectTemplate from './selectTemplate/index.vue'

export default SelectTemplate
